<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>Feedbacks</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field
        v-model="search"
        label="Search"
        single-line
        v-on:keyup.enter="initialize"
        hide-details
      ></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-combobox
        :items="scores"
        v-model="$store.state.feedbacks.scoreSelect"
        item-value="key"
        item-text="value"
        @change="initialize"
        hide-details
        label="Score"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-btn color="primary" dark @click="initialize" class="mb-2"
        >Search</v-btn
      >
    </v-toolbar>
    <v-data-table
      :headers="headers"
      hide-default-footer
      :options.sync="options"
      :items="feedbacks.data"
      :items-per-page="1000"
      class="elevation-1"
    >
      <template v-slot:item.createdDate="{ item }">
        <div>{{ new Date(item.createdDate * 1000) | formatDate }}</div>
      </template>
      <template v-slot:item.userId="{ item }">
        <UserDetailCard
          :userId="item.userId"
          :pictureUrl="item.pictureUrl"
          :userName="item.userName"
        />
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="currentPage"
        @input="pageClick"
        :total-visible="20"
        :length="feedbacks.totalPage"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    UserDetailCard: () => import("@/components/Users/UserDetailCard.vue"),
  },
  name: "FeedbackListCard",
  props: {
    feedbacks: {
      type: Object,
      description: "Feedbacks",
    },
    search: {
      type: String,
      description: "search",
    },
  },
  data() {
    return {
      dialog: false,
      options: {},
      scores: [
        { value: "Tümü", key: -1 },
        { value: 1, key: 1 },
        { value: 2, key: 2 },
        { value: 3, key: 3 },
        { value: 4, key: 4 },
        { value: 5, key: 5 },
      ],
      currentPage: 1,
      headers: [
        { text: "User", value: "userId" },
        { text: "Message", value: "message" },
        { text: "Score", value: "score" },
        { text: "Created Date", value: "createdDate" },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        if (this.options.sortBy.length > 0) this.initialize();
      },
      deep: true,
    },
  },
  methods: {
    async initialize() {
      this.feedbacks = await this.$store.dispatch("feedbacks/getAll", {
        page: this.currentPage - 1,
        search: this.search,
        options: this.options,
      });
    },
    pageClick(a) {
      this.currentPage = a;
      this.initialize();
    },
  },
  async mounted() {
    await this.initialize();
  },
};
</script>
